import api from './api';

/**
 * Favorites API Service
 */

// Add place to favorites
export const addToFavorites = async (placeId) => {
  try {
    const response = await api.post('/favorites', { placeId });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Remove from favorites
export const removeFromFavorites = async (favoriteId) => {
  try {
    const response = await api.delete(`/favorites/${favoriteId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get all user's favorites
export const getFavorites = async () => {
  try {
    const response = await api.get('/favorites/my');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Check if place is in favorites
export const checkIsFavorite = async (placeId) => {
  try {
    const response = await api.get(`/favorites/check/${placeId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Toggle favorite status
export const toggleFavorite = async (placeId, currentFavoriteId) => {
  try {
    if (currentFavoriteId) {
      // Remove from favorites
      return await removeFromFavorites(currentFavoriteId);
    } else {
      // Add to favorites
      return await addToFavorites(placeId);
    }
  } catch (error) {
    throw error;
  }
};

const favoritesService = {
  addToFavorites,
  removeFromFavorites,
  getFavorites,
  checkIsFavorite,
  toggleFavorite,
};

export default favoritesService;
